export default {
  component: () => import('./page.vue'),
  path: '/hotel/privacy',
  name: 'hotel-privacy',
  meta: {
    title: '隐私协议',
    auth: false,
    needPhone: false,
    wechat: {
      TimelineShare: false,
      baseAuth: false,
    },
  },
};
